// libraries
import React from "react";

// components
import { SmartHoldsSections } from "../web-settings";

import { TravelTimeGoal } from "@components/goals-wrapper";
import { SmartHoldSync } from "@components/smart-hold-sync";

// util
import { findGoal, standardGoals } from "@util/goal.util";

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Focus Time Settings
// ~-~-~-~-~-~-~-
interface TravelTimeSettingsProps {
  org: any;
}

const useStyles = makeStyles({
  h2: {
    marginBottom: 14,
  },
});

export const TravelTimeSettings = (props: TravelTimeSettingsProps) => {
  const classes = useStyles();

  const hasTravelTimeGoal = !!findGoal(props.org.userGoals, standardGoals.TravelTime);

  return (
    <div cw-id={`web-settings-${SmartHoldsSections.TravelTime}`}>
      <Typography variant="h2" className={classes.h2}>
        🚗 Travel time
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-9">
        Clockwise can protect you from getting scheduled at times when you might need to travel.{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <Typography variant="h3">
        Would you like Clockwise to preserve travel time for you?
      </Typography>
      <TravelTimeGoal org={props.org} isWebSettings />
      <div style={{ marginBottom: 60 }} />
      <Typography variant="h3">Schedule travel time on your calendar?</Typography>
      <Typography variant="subtitle1" className="cw-mb-5">
        Prevent others from scheduling over your travel time by allowing Clockwise to block it on
        your shared calendar. You can customize the duration of individual Travel Time events or
        remove them if they are not needed.
      </Typography>
      <SmartHoldSync
        smartHoldType={"TravelTime"}
        renderMode={"Toggle"}
        org={props.org}
        allowAutoSave={true}
        disabled={!hasTravelTimeGoal}
      />
    </div>
  );
};
